// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__1xDUL","slider":"style_slider__O_2Ra","round":"style_round__2Wv7q"};